// removed by extract-text-webpack-plugin
module.exports = {"ant-modal-wrap":"ant-modal-wrap","push-modal-wrap":"push-modal-wrap","push-modal":"push-modal","text-red":"text-red","pgx-modal":"pgx-modal","ant-modal-body":"ant-modal-body"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/pgs/ReportDetail/pushModal.scss
// module id = 1408
// module chunks = 0